import type { OrderBookRowItem } from './types'

import { useMemo } from 'react'

import { enrichAndFilterOrders } from './utils'

type UseEnrichedFilteredBidsAsksParams = {
  orders: OrderBookRowItem[]
  minNumBonds?: number
  maxNumBonds?: number
  shouldFilter: boolean
}

export const useEnrichedFilteredBidsAsks = ({
  orders,
  minNumBonds,
  maxNumBonds,
  shouldFilter,
}: UseEnrichedFilteredBidsAsksParams) => {
  return useMemo(() => {
    return enrichAndFilterOrders(orders, shouldFilter, minNumBonds, maxNumBonds)
  }, [orders, minNumBonds, maxNumBonds, shouldFilter])
}
